import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { AuthenticatedRoute } from "./AuthenticatedRoute.jsx";
import { AuthProvider } from "./contexts/authContext";
import { TranslationProvider } from "./contexts/translationContext";
import { NotificationProvider } from "./contexts/notificationContext";

import Login from "./views/Authentication/Login";
import ChangeDefaultPassword from './views/Authentication/ChangeDefaultPassword'

import Import from "./views/AppConfig/Import";
import Export from "./views/AppConfig/Export";
import MenuItems from "./views/AppConfig/MenuItems";
import MenuItem from "./views/AppConfig/MenuItem";
import Tenant from "./views/AppConfig/Tenant";
import Tenants from "./views/AppConfig/Tenants";
import ExternalSystem from "./views/AppConfig/ExternalSystem";
import ExternalSystems from "./views/AppConfig/ExternalSystems";
import Settings from "./views/AppConfig/Settings";
import Translations from "./views/AppConfig/Translations";

import Attachment from "./views/Common/Attachment";
import Home from "./views/Common/Home";

import AttachmentType from "./views/Communication/AttachmentType";
import AttachmentTypes from "./views/Communication/AttachmentTypes";
import DocumentTemplate from "./views/Communication/DocumentTemplate";
import DocumentTemplates from "./views/Communication/DocumentTemplates";
import SendMessage from "./views/Communication/SendMessage";

import ItemRevision from "./views/Items/ItemRevision";
import BillOfMaterials from "./views/Items/BillOfMaterials";
import ItemsOfType from "./views/Items/OfType";

import ProjectDetails from "./views/Projects/ProjectDetails";

import AddressView from "./views/BusinessPartners/Address";
import BusinessPartnerDetails from "./views/BusinessPartners/BusinessPartnerDetails";
import BusinessPartnerGroup from "./views/BusinessPartners/BusinessPartnerGroup";
import Contactperson from "./views/BusinessPartners/Contactperson";

import LicenseDetails from "./views/Licenses/LicenseDetails";

import AddressTypes from "./views/ItemSetup/AddressTypes";
import AddressType from "./views/ItemSetup/AddressType";
import BillOfMaterialTemplates from "./views/ItemSetup/BillOfMaterialTemplates";
import BillOfMaterialTemplate from "./views/ItemSetup/BillOfMaterialTemplate";
import Brands from "./views/ItemSetup/Brands";
import Brand from "./views/ItemSetup/Brand";
import Color from "./views/ItemSetup/Color";
import Colors from "./views/ItemSetup/Colors";
import Countries from "./views/ItemSetup/Countries";
import Country from "./views/ItemSetup/Country";
import Currencies from "./views/ItemSetup/Currencies";
import Currency from "./views/ItemSetup/Currency";
import DesignPhases from "./views/ItemSetup/DesignPhases";
import DesignPhase from "./views/ItemSetup/DesignPhase";
import Divisions from "./views/ItemSetup/Divisions";
import Division from "./views/ItemSetup/Division";
import IncoTerms from "./views/ItemSetup/IncoTerms";
import IncoTerm from "./views/ItemSetup/IncoTerm";
import ItemStatuses from "./views/ItemSetup/ItemStatuses";
import ItemStatus from "./views/ItemSetup/ItemStatus";
import ItemStatusTypes from "./views/ItemSetup/ItemStatusTypes";
import ItemStatusType from "./views/ItemSetup/ItemStatusType";
import ItemTypes from "./views/ItemSetup/ItemTypes";
import ItemType from "./views/ItemSetup/ItemType";
import PriceTypes from "./views/ItemSetup/PriceTypes";
import PriceType from "./views/ItemSetup/PriceType";
import PriceTrancheTypes from "./views/ItemSetup/PriceTrancheTypes";
import PriceTrancheType from "./views/ItemSetup/PriceTrancheType";
import ProductCategories from "./views/ItemSetup/ProductCategories";
import ProductCategory from "./views/ItemSetup/ProductCategory";
import Regions from "./views/ItemSetup/Regions";
import Region from "./views/ItemSetup/Region";
import RoyaltyTypes from "./views/ItemSetup/RoyaltyTypes";
import RoyaltyType from "./views/ItemSetup/RoyaltyType";
import UserDefinedFields from "./views/ItemSetup/UserDefinedFields";
import UserDefinedField from "./views/ItemSetup/UserDefinedField";
import UserDefinedFieldCategories from "./views/ItemSetup/UserDefinedFieldCategories";
import UserDefinedFieldCategory from "./views/ItemSetup/UserDefinedFieldCategory";
import Size from "./views/ItemSetup/Size";
import Sizes from "./views/ItemSetup/Sizes";
import SizeSet from "./views/ItemSetup/SizeSet";
import SizeSets from "./views/ItemSetup/SizeSets";

import SearchAttachmentView from "./views/Search/Attachment";
import SearchItemView from "./views/Search/Item";
import SearchItemAdvancedView from "./views/Search/ItemAdvanced";
import SearchItemNavBarView from "./views/Search/ItemNavBarSearch";
import SearchProjectView from "./views/Search/Project";
import SearchBusinessPartnerView from "./views/Search/BusinessPartner";
import SearchBusinessPartnerGroupsView from "./views/Search/BusinessPartnerGroup";
import SearchLicenseView from "./views/Search/License";
import SearchWorkflowTaskView from "./views/Search/WorkflowTask";
import SearchUserView from "./views/Search/User";
import SearchEmployeeView from "./views/Search/Employee";

import ExportHub from "./views/Export/ExportHub"

import TaskView from "./views/Workflow/Task";
import MyTasksView from "./views/Workflow/MyTasks";

import ActionView from "./views/WorkflowSetup/Action";
import ActionCodeTaskView from "./views/WorkflowSetup/ActionCodeTask";
import EventCodeTaskView from "./views/WorkflowSetup/EventCodeTask";
import MilestoneDefinitionView from "./views/WorkflowSetup/MilestoneDefinition";
import ProjectStatusesView from "./views/WorkflowSetup/ProjectStatuses";
import ProjectStatusView from "./views/WorkflowSetup/ProjectStatus";
import ProjectTypeView from "./views/WorkflowSetup/ProjectType";
import ProjectTypesView from "./views/WorkflowSetup/ProjectTypes";
import WorkflowsView from "./views/WorkflowSetup/Workflows";
import WorkflowView from "./views/WorkflowSetup/Workflow";
import WorkflowStepView from "./views/WorkflowSetup/Step";
import WorkflowTaskView from "./views/WorkflowSetup/Task";
import TaskCategoryView from "./views/WorkflowSetup/TaskCategory";
import TaskCategoriesView from "./views/WorkflowSetup/TaskCategories";

import UserView from "./views/UserManagement/User";
import EmployeeView from "./views/UserManagement/Employee";
import EmployeeMaintenanceView from "./views/UserManagement/EmployeeMaintenance";
import DepartmentView from "./views/UserManagement/Department";
import DepartmentsView from "./views/UserManagement/Departments";
import ApplicationRoleView from "./views/UserManagement/ApplicationRole";
import ApplicationRolesView from "./views/UserManagement/ApplicationRoles";
import FunctionalRoleView from "./views/UserManagement/FunctionalRole";
import FunctionalRolesView from "./views/UserManagement/FunctionalRoles";
import GenderView from "./views/UserManagement/Gender";
import GendersView from "./views/UserManagement/Genders";

//import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/sass/light-bootstrap-dashboard-pro-react.scss?v=1.2.0";
import "./assets/sass/Custom.scss?v=1.2.0";
import "./assets/sass/Spinner.css?v=1.2.0";
//import "./assets/css/demo.css";
import "./assets/css/pe-icon-7-stroke.css";

import AuthLayout from "./layouts/Auth";
import DefaultLayout from "./layouts/Default";

ReactDOM.render(
    <BrowserRouter>
        <AuthProvider>
            <TranslationProvider>
                <NotificationProvider>
                    <Routes>
                        <Route path="auth" element={<AuthLayout />}>
                            <Route path="login" element={<Login />} />
                            <Route path="changeDefaultPassword" element={<ChangeDefaultPassword />} />
                        </Route>
                        <Route path="plm" element={<AuthenticatedRoute><DefaultLayout /></AuthenticatedRoute>}>
                            <Route path="home" element={<Home />} />
                            <Route path="appconfig/import" element={<Import />} />
                            <Route path="appconfig/export" element={<Export />} />
                            <Route path="appconfig/menuitems/" element={<MenuItems />} />
                            <Route path="appconfig/menuitem/:id" element={<MenuItem />} />
                            <Route path="appconfig/tenants/" element={<Tenants />} />
                            <Route path="appconfig/tenant/:id" element={<Tenant />} />
                            <Route path="appconfig/externalsystems/" element={<ExternalSystems />} />
                            <Route path="appconfig/externalsystem/:id" element={<ExternalSystem />} />
                            <Route path="appconfig/settings/" element={<Settings />} />
                            <Route path="appconfig/translations/" element={<Translations />} />

                            <Route path="common/attachment/:id" element={<Attachment />} />

                            <Route path="communication/attachmenttypes" element={<AttachmentTypes />} />
                            <Route path="communication/attachmenttype/:id" element={<AttachmentType />} />
                            <Route path="communication/documenttemplates" element={<DocumentTemplates />} />
                            <Route path="communication/documenttemplate/:id" element={<DocumentTemplate />} />
                            <Route path="communication/sendmessage" element={<SendMessage />} />

                            <Route path="items/itemrevision/:id" element={<ItemRevision />} />
                            <Route path="items/billofmaterials/:id" element={<BillOfMaterials />} />
                            <Route path="items/oftype/:itemTypeId" element={<ItemsOfType />} />
                            <Route path="projects/details/:id" element={<ProjectDetails />} />
                            <Route path="businesspartners/address/:id" element={<AddressView />} />
                            <Route path="businesspartners/contactperson/:id" element={<Contactperson />} />
                            <Route path="businesspartners/details/:id" element={<BusinessPartnerDetails />} />
                            <Route path="businesspartners/businesspartnergroup/:id" element={<BusinessPartnerGroup />} />
                            <Route path="licenses/details/:id" element={<LicenseDetails />} />

                            <Route path="itemsetup/addresstypes" element={<AddressTypes />} />
                            <Route path="itemsetup/addresstype/:id" element={<AddressType />} />
                            <Route path="itemsetup/billofmaterialtemplates/" element={<BillOfMaterialTemplates />} />
                            <Route path="itemsetup/billofmaterialtemplate/:id" element={<BillOfMaterialTemplate />} />
                            <Route path="itemsetup/brands/" element={<Brands />} />
                            <Route path="itemsetup/brand/:id" element={<Brand />} />
                            <Route path="itemsetup/colors" element={<Colors />} />
                            <Route path="itemsetup/color/:id" element={<Color />} />
                            <Route path="itemsetup/countries" element={<Countries />} />
                            <Route path="itemsetup/country/:id" element={<Country />} />
                            <Route path="itemsetup/currencies" element={<Currencies />} />
                            <Route path="itemsetup/currency/:id" element={<Currency />} />
                            <Route path="itemsetup/designphases" element={<DesignPhases />} />
                            <Route path="itemsetup/designphase/:id" element={<DesignPhase />} />
                            <Route path="itemsetup/divisions" element={<Divisions />} />
                            <Route path="itemsetup/division/:id" element={<Division />} />
                            <Route path="itemsetup/incoterms" element={<IncoTerms />} />
                            <Route path="itemsetup/incoterm/:id" element={<IncoTerm />} />
                            <Route path="itemsetup/itemstatuses" element={<ItemStatuses />} />
                            <Route path="itemsetup/itemstatus/:id" element={<ItemStatus />} />
                            <Route path="itemsetup/itemstatustypes" element={<ItemStatusTypes />} />
                            <Route path="itemsetup/itemstatustype/:id" element={<ItemStatusType />} />
                            <Route path="itemsetup/pricetypes" element={<PriceTypes />} />
                            <Route path="itemsetup/pricetype/:id" element={<PriceType />} />
                            <Route path="itemsetup/pricetranchetypes" element={<PriceTrancheTypes />} />
                            <Route path="itemsetup/pricetranchetype/:id" element={<PriceTrancheType />} />
                            <Route path="itemsetup/productcategories" element={<ProductCategories />} />
                            <Route path="itemsetup/productcategory/:id" element={<ProductCategory />} />
                            <Route path="itemsetup/regions" element={<Regions />} />
                            <Route path="itemsetup/region/:id" element={<Region />} />
                            <Route path="itemsetup/royaltytypes" element={<RoyaltyTypes />} />
                            <Route path="itemsetup/royaltytype/:id" element={<RoyaltyType />} />
                            <Route path="itemsetup/userdefinedfields" element={<UserDefinedFields />} />
                            <Route path="itemsetup/userdefinedfield/:id" element={<UserDefinedField />} />
                            <Route path="itemsetup/userdefinedfieldcategories" element={<UserDefinedFieldCategories />} />
                            <Route path="itemsetup/userdefinedfieldcategory/:id" element={<UserDefinedFieldCategory />} />
                            <Route path="itemsetup/itemtypes" element={<ItemTypes />} />
                            <Route path="itemsetup/itemtype/:id" element={<ItemType />} />
                            <Route path="itemsetup/sizes" element={<Sizes />} />
                            <Route path="itemsetup/size/:id" element={<Size />} />
                            <Route path="itemsetup/sizesets" element={<SizeSets />} />
                            <Route path="itemsetup/sizeset/:id" element={<SizeSet />} />

                            <Route path="search/attachment" element={<SearchAttachmentView />} />
                            <Route path="search/item" element={<SearchItemView />} />
                            <Route path="search/itemadvanced" element={<SearchItemAdvancedView />} />
                            <Route path="search/itemnavbar" element={<SearchItemNavBarView /> } />
                            <Route path="search/project" element={<SearchProjectView />} />
                            <Route path="search/license" element={<SearchLicenseView />} />
                            <Route path="search/workflowtask" element={<SearchWorkflowTaskView />} />
                            <Route path="usermanagement/users" element={<SearchUserView /> } />
                            <Route path="usermanagement/employees" element={<SearchEmployeeView />} />
                            <Route path="usermanagement/employeemaintenance" element={<EmployeeMaintenanceView />} />
                            <Route path="businesspartners" element={<SearchBusinessPartnerView />} />
                            <Route path="businesspartners/BusinessPartnerGroups" element={<SearchBusinessPartnerGroupsView />} />

                            <Route path="exportHub" element={<ExportHub />} />

                            <Route path="workflow/task/:id" element={<TaskView />} />
                            <Route path="workflow/mytasks" element={<MyTasksView />} />

                            <Route path="workflowsetup/action/:id" element={<ActionView />} />
                            <Route path="workflowsetup/actioncodetask/:id" element={<ActionCodeTaskView />} />
                            <Route path="workflowsetup/milestoneDefinition/:id" element={<MilestoneDefinitionView />} />
                            <Route path="workflowsetup/projectStatuses" element={<ProjectStatusesView />} />
                            <Route path="workflowsetup/projectStatus/:id" element={<ProjectStatusView />} />
                            <Route path="workflowsetup/projectTypes" element={<ProjectTypesView />} />
                            <Route path="workflowsetup/projectType/:id" element={<ProjectTypeView />} />
                            <Route path="workflowsetup/WorkflowEventCodeTask/:id" element={<EventCodeTaskView />} />
                            <Route path="workflowsetup/workflows" element={<WorkflowsView />} />
                            <Route path="workflowsetup/workflow/:id" element={<WorkflowView />} />
                            <Route path="workflowsetup/workflowstep/:id" element={<WorkflowStepView />} />
                            <Route path="workflowsetup/workflowtask/:id" element={<WorkflowTaskView />} />
                            <Route path="workflowsetup/taskCategory/:id" element={<TaskCategoryView />} />
                            <Route path="workflowsetup/taskCategories" element={<TaskCategoriesView />} />

                            <Route path="usermanagement/user/:id" element={<UserView />} />
                            <Route path="usermanagement/employee/:id" element={<EmployeeView />} />
                            <Route path="usermanagement/department/:id" element={<DepartmentView />} />
                            <Route path="usermanagement/departments" element={<DepartmentsView />} />
                            <Route path="usermanagement/gender/:id" element={<GenderView />} />
                            <Route path="usermanagement/genders" element={<GendersView />} />
                            <Route path="usermanagement/applicationroles" element={<ApplicationRolesView />} />
                            <Route path="usermanagement/applicationrole/:id" element={<ApplicationRoleView />} />
                            <Route path="usermanagement/functionalroles" element={<FunctionalRolesView />} />
                            <Route path="usermanagement/functionalrole/:id" element={<FunctionalRoleView />} />
                        </Route>
                        <Route path="/" element={<Navigate replace to='/plm/home' />} />
                    </Routes>
                </NotificationProvider>
            </TranslationProvider>
        </AuthProvider>
    </BrowserRouter>

    , document.getElementById("root")
);
